/*
 * Wuselzeit — Meta-Tracking im Shop
 *
 * Drei Aufgaben, in dieser Reihenfolge:
 *
 *   1. Einwilligung abwarten.  Vor einem "Ja" wird nichts geladen, nichts
 *      gespeichert und nichts gesendet (§ 25 TDDDG, Art. 6 Abs. 1 lit. a
 *      DSGVO).  Serverseitiges Tracking aendert daran nichts — ein
 *      SHA-256-Hash einer E-Mail ist pseudonymisiert, nicht anonym.
 *
 *   2. Die Meta-Kennungen _fbp und _fbc sichern.  Wird fbevents.js von einem
 *      Werbeblocker verschluckt — je nach Zielgruppe 15 bis 30 % der
 *      Besucher — entstehen diese Cookies nie, und der Kauf laesst sich
 *      spaeter keiner Anzeige zuordnen.  Diese Datei liegt auf der
 *      Shop-Domain und wird deshalb ausgeliefert.  Sie legt die Kennungen im
 *      selben Format selbst an, wenn sie fehlen.
 *
 *   3. Die Standard-Events feuern und die Kennungen an den Checkout
 *      weiterreichen.  Der Kauf selbst wird NICHT hier gemeldet: Er schliesst
 *      bei Stripe ab, wo kein Pixel liegt.  Das uebernimmt der Server.
 *
 *   4. Seitenaufruf, Produktansicht und Warenkorb zusaetzlich an unseren
 *      eigenen Server schicken (checkout.wuselzeit.de/ereignis, seit
 *      28.09.2026).  Der reicht sie an Metas Conversions API weiter — mit
 *      derselben event_id wie das Pixel, damit Meta beide als EIN Ereignis
 *      zaehlt.  Eine Anfrage an die eigene Subdomain blockiert kein
 *      Werbeblocker.  Dazu gehoert unsere eigene Besucher-ID (Cookie wz_id),
 *      die Shop-Ereignisse und den spaeteren Kauf verbindet.  Auch das nur
 *      nach einem "Ja".
 */
(function () {
  'use strict';

  var PIXEL_ID = window.WUSELZEIT_PIXEL_ID || '';
  var COOKIE_DAYS = 90;
  // Einkauf, Kasse und Zahlung meldet der Checkout-Server selbst, sobald er
  // sie sieht. Hier geht nur hin, was er sonst nie erfaehrt.
  var SERVER_EVENTS = { PageView: true, ViewContent: true, AddToCart: true, Search: true,
                        CustomizeProduct: true, Contact: true, Lead: true, ViewIn3D: true };
  // Eigene Ereignisse (kein Meta-Standard) gehen ueber trackCustom.
  var CUSTOM_EVENTS = { ViewIn3D: true };
  // Gleicher Server wie der Checkout, nur ein anderer Pfad.
  var EVENTS_URL = window.WUSELZEIT_EVENTS_URL
    || (window.WUSELZEIT_CHECKOUT_URL || 'https://checkout.wuselzeit.de/checkout')
      .replace(/\/checkout\/?$/, '') + '/ereignis';
  var BESUCHER_COOKIE = 'wz_id';
  var BESUCHER_TAGE = 180;
  // Meta behaelt von zwei Kopien desselben Ereignisses die ZUERST
  // eingetroffene. Das Browser-Pixel braucht erst fbevents.js, die
  // Server-Kopie waere sofort da -- dann gewaenne der Server, und dem fehlen
  // Metas eigene Browser-Signale fuer die Zuordnung zur Anzeige (gesehen
  // 29.09.2026). Deshalb wartet die Server-Kopie; beim Verlassen der Seite
  // geht sie sofort raus.
  var SERVER_DELAY_MS = typeof window.WUSELZEIT_SERVER_DELAY_MS === 'number' ? window.WUSELZEIT_SERVER_DELAY_MS : 4000;
  var wartend = [];
  var state = { consent: 'unknown', pixelLoaded: false, queue: [] };

  // ---------------------------------------------------------------------
  // Cookies
  // ---------------------------------------------------------------------

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function writeCookie(name, value, tage) {
    var expires = new Date(Date.now() + (tage || COOKIE_DAYS) * 86400000).toUTCString();
    // Auf die registrierbare Domain schreiben, damit www und die nackte
    // Domain dieselbe Kennung sehen. Sonst zaehlt Meta einen Besucher, der
    // ueber www einsteigt und ohne www kauft, als zwei verschiedene.
    var parts = window.location.hostname.split('.');
    var domain = parts.length > 2 ? '.' + parts.slice(-2).join('.') : '.' + parts.join('.');
    var suffix = '; expires=' + expires + '; path=/; SameSite=Lax'
      + (window.location.protocol === 'https:' ? '; Secure' : '');
    document.cookie = name + '=' + encodeURIComponent(value) + '; domain=' + domain + suffix;
    // Falls die Domain-Variante abgelehnt wurde (etwa bei localhost oder
    // einer .myshopify.com-Vorschau), ohne Domain nachlegen.
    if (!readCookie(name)) document.cookie = name + '=' + encodeURIComponent(value) + suffix;
  }

  function deleteCookie(name) {
    var parts = window.location.hostname.split('.');
    var domain = parts.length > 2 ? '.' + parts.slice(-2).join('.') : '.' + parts.join('.');
    var tot = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = tot + '; domain=' + domain;
    document.cookie = tot;
  }

  function queryParam(name) {
    var match = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // ---------------------------------------------------------------------
  // _fbp / _fbc
  //
  // Format in beiden Faellen: fb.<subdomain-index>.<zeit-in-ms>.<kennung>
  // Der Zeitstempel steht hier in MILLISEKUNDEN — anders als event_time im
  // Server-Event, das Sekunden verlangt. Die Verwechslung ist der haeufigste
  // Fehler an dieser Stelle.
  // ---------------------------------------------------------------------

  function ensureFbc() {
    var existing = readCookie('_fbc');
    // Ein vorhandenes Cookie hat Vorrang: Es traegt den urspruenglichen
    // Klickzeitpunkt, und den kann man nicht rekonstruieren.
    if (existing) return existing;

    var fbclid = queryParam('fbclid');
    if (!fbclid) return null;

    var value = 'fb.1.' + Date.now() + '.' + fbclid;
    writeCookie('_fbc', value);
    return value;
  }

  function ensureFbp() {
    var existing = readCookie('_fbp');
    if (existing) return existing;

    // Zehnstellige Zufallszahl, genau wie das Original. Schreiben ist
    // gefahrlos: Laedt fbevents.js spaeter doch, uebernimmt es ein
    // vorhandenes _fbp, statt ein zweites anzulegen.
    var random = String(Math.floor(Math.random() * 9000000000) + 1000000000);
    var value = 'fb.1.' + Date.now() + '.' + random;
    writeCookie('_fbp', value);
    return value;
  }

  // ---------------------------------------------------------------------
  // Eigene Besucher-ID und event_id
  // ---------------------------------------------------------------------

  function zufallHex(bytes) {
    var hex = '';
    try {
      var werte = new Uint8Array(bytes);
      window.crypto.getRandomValues(werte);
      for (var i = 0; i < werte.length; i++) hex += ('0' + werte[i].toString(16)).slice(-2);
    } catch (e) {
      while (hex.length < bytes * 2) hex += Math.floor(Math.random() * 16).toString(16);
    }
    return hex.slice(0, bytes * 2);
  }

  // 32 Hex-Zeichen, genau das Format, das der Server annimmt. Der Server
  // setzt dasselbe Cookie bei jeder Antwort noch einmal (Server-Cookie).
  function ensureBesucherId() {
    var vorhanden = readCookie(BESUCHER_COOKIE);
    if (/^[a-f0-9]{32}$/.test(vorhanden || '')) return vorhanden;
    var id = zufallHex(16);
    writeCookie(BESUCHER_COOKIE, id, BESUCHER_TAGE);
    return id;
  }

  // Kuerzel + Zeit + Zufall, z. B. "vi-lx3k9ab-0123456789abcdef". Eindeutig
  // genug, dass Meta nie zwei verschiedene Produktansichten verwechselt.
  function neueEventId(name) {
    return String(name).slice(0, 2).toLowerCase() + '-' + Date.now().toString(36) + '-' + zufallHex(8);
  }

  // Als Text, nicht als JSON-Blob: Dann schickt der Browser keine
  // CORS-Vorabanfrage, und sendBeacon kommt auch beim Verlassen der Seite
  // noch an. Die Antwort braucht niemand.
  function anServer(name, data, eventId) {
    if (!SERVER_EVENTS[name] || !EVENTS_URL) return;
    var body;
    try {
      body = JSON.stringify({
        event_name: name,
        event_id: eventId,
        custom_data: data || {},
        page_url: window.location.href.split('#')[0],
        fbp: readCookie('_fbp'),
        fbc: readCookie('_fbc'),
        besucher_id: readCookie(BESUCHER_COOKIE),
        consent: state.consent,
        analytics: readAnalytics()
      });
    } catch (e) { return; }

    if (SERVER_DELAY_MS <= 0) { sendeAnServer(body); return; }
    var eintrag = { body: body };
    eintrag.timer = setTimeout(function () {
      var i = wartend.indexOf(eintrag);
      if (i !== -1) wartend.splice(i, 1);
      sendeAnServer(body);
    }, SERVER_DELAY_MS);
    wartend.push(eintrag);
  }

  function wartendeSenden() {
    var liste = wartend.splice(0, wartend.length);
    for (var i = 0; i < liste.length; i++) {
      clearTimeout(liste[i].timer);
      sendeAnServer(liste[i].body);
    }
  }

  function sendeAnServer(body) {
    try {
      if (window.navigator && typeof window.navigator.sendBeacon === 'function'
          && window.navigator.sendBeacon(EVENTS_URL, body)) return;
    } catch (e) { /* weiter mit fetch */ }

    try {
      window.fetch(EVENTS_URL, {
        method: 'POST', body: body, keepalive: true, mode: 'no-cors', credentials: 'include',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
      }).catch(function () {});
    } catch (e) { /* Tracking darf den Shop nie stoeren. */ }
  }

  // ---------------------------------------------------------------------
  // Einwilligung
  // ---------------------------------------------------------------------

  function readConsent() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      // Kein Banner im Shop eingerichtet: weder erlaubt noch abgelehnt.
      // Diesen Fall still als Ablehnung zu behandeln waere die unsichtbare
      // Variante von "es trackt nichts und keiner weiss warum" — deshalb ein
      // eigener Zustand, ueber den der Server entscheidet.
      if (!api || typeof api.marketingAllowed !== 'function') return 'unknown';
      return api.marketingAllowed() ? 'granted' : 'denied';
    } catch (e) {
      return 'unknown';
    }
  }

  // Shopify fuehrt "Analysen" getrennt von "Marketing". Unser eigener
  // Trichter auf dem Server speichert nur mit einem Ja fuer Analysen.
  function readAnalytics() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return 'unknown';
      return api.analyticsProcessingAllowed() ? 'granted' : 'denied';
    } catch (e) {
      return 'unknown';
    }
  }

  function onConsentChange() {
    var next = readConsent();
    if (next === state.consent) return;
    state.consent = next;
    if (next === 'granted') activate();
    // Wer sein Ja zuruecknimmt, ist die Kennungen los -- sonst reiste die
    // Besucher-ID noch 180 Tage auf jeder Anfrage mit.
    if (next === 'denied') { deleteCookie(BESUCHER_COOKIE); deleteCookie('_fbp'); deleteCookie('_fbc'); }
  }

  function watchConsent() {
    state.consent = readConsent();
    document.addEventListener('visitorConsentCollected', onConsentChange);

    // Die Consent-API laedt Shopify nachtraeglich. Ohne loadFeatures ist sie
    // auf vielen Themes beim ersten Aufruf schlicht noch nicht da.
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { onConsentChange(); }
        );
      }
    } catch (e) { /* Theme ohne Consent-API — bleibt bei 'unknown'. */ }

    if (state.consent === 'granted') activate();
  }

  // ---------------------------------------------------------------------
  // Pixel
  // ---------------------------------------------------------------------

  // Metas Standard-Snippet, aber lesbar und ohne seine Bruchstelle: Das
  // Original haengt das Script vor das erste <script> im Dokument und stuerzt
  // ab, wenn es keins gibt. Hier gibt es einen Rueckfallweg.
  function installFbqStub() {
    if (window.fbq) return;
    var fbq = function () {
      // Vor dem Laden von fbevents.js sammeln, danach durchreichen.
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
  }

  function injectPixelScript() {
    var tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://connect.facebook.net/en_US/fbevents.js';

    var first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) first.parentNode.insertBefore(tag, first);
    else (document.head || document.documentElement).appendChild(tag);
  }

  function loadPixel() {
    if (state.pixelLoaded || !PIXEL_ID) return;
    state.pixelLoaded = true;

    installFbqStub();
    injectPixelScript();

    // Kein consent revoke/grant: loadPixel laeuft ohnehin nur nach einem Ja
    // (siehe activate), vor der Einwilligung wird fbevents.js gar nicht erst
    // geladen. Bis 24.09.2026 stand hier revoke -> init -> grant. Weil alle
    // drei in der Stub-Warteschlange landen, bevor fbevents.js da ist, blieb
    // fbevents.js beim revoke stehen und kam nie beim grant an -- das Pixel
    // hat so kein einziges Browser-Event gesendet (Test 14).
    // Besucher-ID als Advanced Matching auch ins Browser-Pixel: Meta behaelt
    // bei Duplikaten meist das Browser-Ereignis, und ohne external_id dort
    // hinge der Kauf nur bei Werbeblocker-Nutzern an den Shop-Ereignissen.
    // Das Pixel hasht den Wert selbst (SHA-256), genau wie unser Server.
    var besucher = readCookie(BESUCHER_COOKIE);
    if (besucher) window.fbq('init', PIXEL_ID, { external_id: besucher });
    else window.fbq('init', PIXEL_ID);
    // init allein feuert keinen Seitenaufruf — der gehoert ausdruecklich
    // dazu, sonst fehlt Meta die Grundlage fuer Reichweite und Retargeting.
    // Ueber track(), damit er auch an den eigenen Server geht.
    track('PageView', {});
  }

  function activate() {
    // Ohne Pixel-ID gibt es niemanden, der die Kennungen auswerten koennte --
    // dann werden auch keine gesetzt. Cookies auf Vorrat anzulegen waere
    // genau die Art von stillem Nebeneffekt, die man spaeter erklaeren muss.
    if (!PIXEL_ID) return;

    ensureFbp();
    ensureFbc();
    ensureBesucherId();
    loadPixel();

    var pending = state.queue.splice(0, state.queue.length);
    for (var i = 0; i < pending.length; i++) track(pending[i][0], pending[i][1], pending[i][2]);
  }

  // eventId sorgt fuer die Entdopplung gegen das Server-Event: Meta wirft ein
  // Browser- und ein Server-Event zusammen, wenn event_name UND event_id
  // uebereinstimmen und beide binnen 48 Stunden ankommen. Fehlt sie, wird
  // hier eine vergeben -- Pixel und eigener Server bekommen dieselbe.
  function track(name, data, eventId) {
    if (state.consent !== 'granted') {
      // Vor der Einwilligung nur merken, nicht senden. Bis zu zwanzig
      // Ereignisse — genug fuer einen Seitenbesuch, und keine Halde, falls
      // nie eingewilligt wird.
      if (state.queue.length < 20) state.queue.push([name, data, eventId]);
      return;
    }
    if (!window.fbq) return;
    var id = eventId || neueEventId(name);
    window.fbq(CUSTOM_EVENTS[name] ? 'trackCustom' : 'track', name, data || {}, { eventID: id });
    anServer(name, data, id);
  }

  // ---------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------

  function contentId(item) {
    var format = window.WUSELZEIT_CONTENT_ID_FORMAT || 'variant';
    if (format === 'sku' && item.sku) return String(item.sku);
    if (format === 'shopify' && item.product_id) {
      return 'shopify_' + (window.WUSELZEIT_CATALOG_COUNTRY || 'DE')
        + '_' + item.product_id + '_' + item.variant_id;
    }
    return String(item.variant_id);
  }

  function trackViewContent() {
    var product = window.WUSELZEIT_PRODUCT;
    if (!product || !product.variant_id) return;

    track('ViewContent', {
      content_type: 'product',
      content_ids: [contentId(product)],
      content_name: product.title,
      value: product.price,
      currency: 'EUR'
    });
  }

  // Der Warenkorb wird in jedem Theme anders befuellt: per fetch, per
  // XMLHttpRequest, per klassischem Formular. Statt auf theme-eigene Events
  // zu hoffen — die es je nach Theme gibt oder nicht — werden die Aufrufe an
  // /cart/add abgefangen. Das trifft alle drei Wege.
  function isCartAdd(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  // Die Antwort von /cart/add.js nennt die Gesamtmenge der Zeile, nicht die
  // gerade hinzugefuegte. Die steht nur in der Anfrage.
  function requestedQuantities(body) {
    var mengen = {};
    try {
      if (typeof body === 'string' && /^\s*\{/.test(body)) {
        var json = JSON.parse(body);
        var liste = json.items || [json];
        for (var i = 0; i < liste.length; i++) {
          mengen[String(liste[i].id)] = parseInt(liste[i].quantity, 10) || 1;
        }
      } else if (body && typeof body.get === 'function') {
        mengen['*'] = parseInt(body.get('quantity'), 10) || 1;   // FormData
      } else if (typeof body === 'string') {
        mengen['*'] = parseInt(new URLSearchParams(body).get('quantity'), 10) || 1;
      }
    } catch (e) { /* Unbekanntes Format: dann zaehlt ein Stueck. */ }
    return mengen;
  }

  function trackAddToCart(antwort, body) {
    // Bevorzugt die Antwort von /cart/add.js: Sie enthaelt genau die
    // hinzugefuegten Positionen. Im Warenkorb dagegen steht die ganze Zeile
    // (drei Sofas = dreifacher Preis), und welche Position die neue ist, sagt
    // er nicht verlaesslich.
    var added = antwort && (antwort.items || (antwort.variant_id ? [antwort] : null));
    if (added && added.length) {
      var mengen = requestedQuantities(body);
      var ids = [], namen = [], wert = 0;
      for (var i = 0; i < added.length; i++) {
        var item = added[i];
        var menge = mengen[String(item.variant_id)] || mengen[String(item.id)] || mengen['*'] || 1;
        ids.push(contentId(item));
        namen.push(item.product_title);
        wert += (item.final_price || item.price || 0) * menge;
      }
      track('AddToCart', {
        content_type: 'product',
        content_ids: ids,
        content_name: namen.join(', '),
        value: wert / 100,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      });
      return;
    }

    // Rueckfallweg ohne verwertbare Antwort (klassisches Formular): den
    // Warenkorb lesen und den Preis eines Stuecks melden.
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var last = cart.items[cart.items.length - 1];
        track('AddToCart', {
          content_type: 'product',
          content_ids: [contentId(last)],
          content_name: last.product_title,
          value: (last.final_line_price || last.line_price || 0) / (last.quantity || 1) / 100,
          currency: (cart.currency || 'EUR')
        });
      })
      .catch(function () { /* Tracking darf den Warenkorb nie stoeren. */ });
  }

  function interceptCartAdd() {
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url);
        var result = originalFetch.apply(this, arguments);
        if (isCartAdd(url)) {
          var body = init && init.body;
          result.then(function (res) {
            if (!res || !res.ok) return;
            // Kopie lesen, damit das Theme seine Antwort unberuehrt bekommt.
            var kopie = typeof res.clone === 'function' ? res.clone() : null;
            if (!kopie) { trackAddToCart(null, body); return; }
            kopie.json().then(
              function (data) { trackAddToCart(data, body); },
              function () { trackAddToCart(null, body); }
            );
          }).catch(function () {});
        }
        return result;
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__wuselzeitCartAdd = isCartAdd(url);
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__wuselzeitCartAdd) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          var data = null;
          try {
            data = this.responseType === 'json' ? this.response : JSON.parse(this.responseText);
          } catch (e) { /* keine JSON-Antwort -> Rueckfallweg */ }
          trackAddToCart(data, body);
        });
      }
      return originalSend.apply(this, arguments);
    };

    // Themes ohne JavaScript-Warenkorb schicken ein echtes Formular ab. Die
    // meisten, auch Impact, fangen das Absenden aber ab und rufen /cart/add.js
    // selbst auf -- das zaehlt schon der fetch-Weg oben. Deshalb erst nach dem
    // Durchlauf des Events schauen, ob das Theme es abgefangen hat. Vorher kam
    // jeder Klick doppelt bei Meta an (gesehen am 24.09.2026).
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.action || !isCartAdd(form.action)) return;
      setTimeout(function () { if (!event.defaultPrevented) trackAddToCart(); }, 0);
    }, true);
  }

  // ---------------------------------------------------------------------
  // Alles, was sonst noch zaehlt (Niclas 28.09.2026: "alles tracken, was
  // geht"): Suche, Variantenwechsel, Kontakt, Newsletter, 3D-Ansicht.
  // ---------------------------------------------------------------------

  function trackSearch() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var begriff = (queryParam('q') || '').replace(/\+/g, ' ').trim();
    if (!begriff) return;
    track('Search', { search_string: begriff.slice(0, 100) });
  }

  function produktDaten(variantId) {
    var product = window.WUSELZEIT_PRODUCT || {};
    var data = { content_type: 'product' };
    var id = variantId || product.variant_id;
    if (id) data.content_ids = [String(id)];
    if (product.title) data.content_name = product.title;
    return data;
  }

  function interceptRest() {
    // Variantenwechsel: Das Feld "id" im Produktformular. Delegation auf
    // document, weil Themes das Formular bei jeder Auswahl neu rendern.
    document.addEventListener('change', function (event) {
      var feld = event.target;
      if (!feld || feld.name !== 'id' || !feld.value) return;
      track('CustomizeProduct', produktDaten(feld.value));
    });

    document.addEventListener('click', function (event) {
      var ziel = event.target;
      if (!ziel || typeof ziel.closest !== 'function') return;

      var kontakt = ziel.closest('a[href^="mailto:"], a[href^="tel:"], a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
      if (kontakt) { track('Contact', {}); return; }

      // Shopifys 3D-Modell (model-viewer) und unser "In 3D ansehen"-Link.
      var dreid = ziel.closest('a[href*="#wz-3d"], model-viewer, .shopify-model-viewer-ui, [data-shopify-xr], .product-model');
      if (dreid) track('ViewIn3D', produktDaten());
    }, true);

    // Newsletter: Shopifys Kundenformular mit Tag "newsletter". Die
    // Kontaktfrage laeuft ueber dasselbe /contact, zaehlt aber nicht.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/contact') === -1) return;
      var tags = form.querySelector('input[name="contact[tags]"]');
      var newsletter = (tags && /newsletter/i.test(tags.value)) || /newsletter|nlform/i.test(form.className || '');
      if (!newsletter) return;
      // Nur die Tatsache, nie die Adresse.
      track('Lead', {});
    }, true);
  }

  // ---------------------------------------------------------------------
  // Schnittstelle fuer wuselzeit-checkout.js
  // ---------------------------------------------------------------------

  window.WuselzeitTracking = {
    // Die Werte, die der Checkout an den Server weiterreicht. Sie muessen von
    // hier kommen: Der Checkout laeuft auf einer anderen Domain und kann die
    // Cookies des Shops nicht lesen.
    signals: function () {
      return {
        fbp: state.consent === 'granted' ? readCookie('_fbp') : null,
        fbc: state.consent === 'granted' ? readCookie('_fbc') : null,
        besucher_id: state.consent === 'granted' ? readCookie(BESUCHER_COOKIE) : null,
        page_url: window.location.href.split('#')[0],
        consent: state.consent
      };
    },
    track: track,
    consent: function () { return state.consent; }
  };

  window.addEventListener('pagehide', wartendeSenden);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') wartendeSenden();
  });

  watchConsent();
  interceptCartAdd();
  interceptRest();
  trackSearch();
  trackViewContent();
})();
